import { render, staticRenderFns } from "./engineering.vue?vue&type=template&id=5bc012b6&scoped=true"
import script from "./engineering.vue?vue&type=script&lang=js"
export * from "./engineering.vue?vue&type=script&lang=js"
import style0 from "./engineering.vue?vue&type=style&index=0&id=5bc012b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc012b6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextPressure: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/text-pressure.vue').default,AuroraBackground: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/aurora-background.vue').default,PageBottom: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/page-bottom/index.vue').default})
